// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","container":"_2sP6BdmsE1kB5jhu_oHsd7"};